var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"nav"},[_c('a',{staticClass:"nav-link nav-link-icon toggle-sidebar d-md-inline d-lg-none text-center",attrs:{"href":"#"},on:{"click":function($event){return _vm.handleClick()}}},[_c('i',{staticClass:"material-icons"},[_vm._v("")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7bc1282a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/MainNavbar/NavbarToggle.vue
// module id = null
// module chunks = 